<template>
  <div v-if="role !== undefined" class="ri-card">
    <div class="ri-card__info">
      <div class="ri-card__title">{{ role.libelle }}</div>
      <span class="ov-badge ov-badge--navy ov-badge--plain ri-card__code">{{ role.code }}</span>
    </div>
    <button type="button" class="ov-icon-btn" :title="$t('role.editRole')" @click="$emit('edit', role)">
      <v-icon small>mdi-pencil-outline</v-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "RoleItem",
  props: {
    role: {
      type: Object,
      default: null,
    },
  },
  emits: ["edit"],
};
</script>

<style lang="scss" scoped>
@import "../../../styles/admin/ui";

.ri-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid $ov-line;
  border-radius: 14px;
  font-family: "Montserrat", sans-serif;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: rgba(21, 158, 114, 0.35);
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  }
}

.ri-card__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.ri-card__title {
  max-width: 100%;
  font-size: 15px;
  font-weight: 800;
  color: $ov-navy;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ri-card__code {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
